import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface BookingSignInPromptProps {
  onContinue: () => void;
}

const BookingSignInPrompt: React.FC<BookingSignInPromptProps> = ({ onContinue }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 2, maxWidth: 800, mx: 'auto', width: '100%' }}>
      <Paper elevation={3} sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          {t('auth.enterPhoneNumber', 'Enter phone number')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {t('bookingSteps.signInOrCreateAccount')}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Button
            variant="contained"
            size="small"
            onClick={onContinue}
            sx={{
              display: 'inline-flex',
              width: 'auto',
              maxWidth: '100%',
              minHeight: 44,
              py: 1,
              px: 3,
              textTransform: 'none',
              letterSpacing: 'normal',
              fontWeight: 600,
              fontSize: '0.9375rem',
              lineHeight: 1.35,
              borderRadius: '12px',
            }}
          >
            {t('auth.signInWithPhone', 'Continue with phone')}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default BookingSignInPrompt;
